const state = {
  available: null,
  errorOnInvest: undefined,
  invest: null,
  isInvestPending: false
}

export default state
